import React from 'react'

const ProjectCard = ({ project }) => {
    return (
        <a href={project.link} target="_blank" className="flex flex-row p-4 bg-white rounded-lg h-60 border-2 px-10 hover:border-gray-400">
            <img alt={project.title} className="object-contain w-1/2" src={`./img/${project.image}`} />
            <div className="flex flex-col w-60">
                <p className="text-3xl font-bold mb-2 font-title">{project.title}</p>
                <p className="text-md font-semi mb-2 font-title">{project.subtitle}</p>
                <p className="text-md mb-2 font-body">{project.description}</p>
            </div>
        </a>
    )
}

export default ProjectCard;


// WEBPACK FOOTER //
// ./src/components/ProjectCard.jsx